import React from 'react';
import dude from './images/logo.png';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const spinnerIco = <LoadingOutlined style={{ fontSize: 24, color: '#FC6214' }} spin />;

const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    font-size: 26px;
`;

const CenterBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: absolute;
    top: 50%;
`;

class Loading extends React.Component {
    render() {
        return (
            <LoadingContainer>
                <CenterBlock>
                    <Spin indicator={spinnerIco} />
                    <div> Loading your ride... </div>
                </CenterBlock>
                <img style={{ position: 'absolute', bottom: '70px' }} className='dude' src={dude} alt='dude' />
            </LoadingContainer>
        );
    }
}

export default Loading;
